var map = {
	"./book_2.png": "ol7K",
	"./code_2.png": "Wu2e",
	"./conversation_2.png": "uj03",
	"./error_2.png": "Zwdl",
	"./fire_2.png": "0E9M",
	"./flag_2.png": "kJBS",
	"./gutachten_2.png": "uYll",
	"./handshake_2.png": "Dv/5",
	"./lab_2.png": "xTz2",
	"./lightbulb_2.png": "veVl",
	"./note_2.png": "3txG",
	"./person_2.png": "0pwo",
	"./present_2.png": "zWQd",
	"./quote_2.png": "HDJS",
	"./search_2.png": "BkWO",
	"./statistics_2.png": "zZ8o",
	"./target_2.png": "gVUJ",
	"./warning_2.png": "2MNz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TWvt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*_2\.png$
// module id = TWvt
// module chunks = 1